'use client';

export { usePostHog as useAnalytics } from 'posthog-js/react';
